import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import ArtworkDetails from "./pages/ArtworkDetails";
import EditArtwork from "./pages/EditArtwork";
import Settings from "./pages/Settings";
import Login from "./components/Auth/Login";
import Register from "./components/Auth/Register";
import ArtworkForm from "./components/ArtworkForm";
import ArtworkList from "./pages/ArtworkList";
import useAuth from "./hooks/useAuth";
import NextActionsView from "./components/NextActionsView";

const App: React.FC = () => {
  const { user, loading } = useAuth();

  // Loading screen migliorato
  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        }}
      >
        <div
          style={{
            textAlign: "center",
            background: "white",
            padding: "40px",
            borderRadius: "20px",
            boxShadow: "0 15px 35px rgba(0, 0, 0, 0.1)",
          }}
        >
          <div
            style={{
              fontSize: "3em",
              marginBottom: "20px",
            }}
          >
            🎨
          </div>
          <div
            style={{
              width: "50px",
              height: "50px",
              border: "4px solid #f3f3f3",
              borderTop: "4px solid #667eea",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
              margin: "0 auto 20px",
            }}
          ></div>
          <p
            style={{
              margin: 0,
              color: "#333",
              fontSize: "1.1em",
              fontWeight: "500",
            }}
          >
            Loading D'Asaro Artwork Tracker...
          </p>
          <style>{`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      </div>
    );
  }

  // Se l'utente non è loggato, mostra solo login/register
  if (!user) {
    return (
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    );
  }

  // Se l'utente è loggato, mostra l'app completa
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/artworks" element={<ArtworkList />} />
          <Route path="/artworks/:id/edit" element={<EditArtwork />} />
          <Route path="/artwork/:id" element={<ArtworkDetails />} />
          <Route path="/edit-artwork/:id" element={<EditArtwork />} />
          <Route path="/next-actions" element={<NextActionsView />} />

          <Route path="/settings" element={<Settings />} />
          <Route
            path="/add-artwork"
            element={
              <ArtworkForm onSubmit={() => (window.location.href = "/")} />
            }
          />
          <Route path="/login" element={<Navigate to="/" replace />} />
          <Route path="/register" element={<Navigate to="/" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </Router>
  );
};

export default App;
